import ReactDOM from "react-dom";
import Cache from "../src/js/cache";
import DesignCenterHeader from "../src/js/components/designcenterheader/designcenterHeader";
import DesignCenterHeadline from "../src/js/components/designcenterheadline/designcenterHeadline";
import DesignCenterPreview from "../src/js/components/designcenter/designcenterPreview";
import React from "react";
import qs from 'query-string';
import { Base64 } from 'js-base64';
import {subscribeBoxSwitch} from "../modules/footer/footer";


const designCenterPreviewNamespaces = ['design-center'];
const customHeaderNamespaces = ['design-center', 'cart', 'checkout'];
const customFooterNamespaces = ['design-center', 'cart', 'checkout', 'category'];


export function createBarbaPage (options) {
    const { onEnter, onEnterCompleted, onLeave, onLeaveCompleted, ...rest } = options;
    return Barba.BaseView.extend({
        ...rest,
        onEnter: function () {
            // add global code for every page
            console.log(`Enter Page ${this.namespace}`);

            // Hide Main Sidebar when Change Page
            $('#navbarTogglerHeader').collapse('hide');
            // Hide Design Center Sidebar
            $('#designCenterNav').collapse('hide');

            // Switch subscribe box in footer from span to input on click
            if ($('#subEmailSpan').length) {
                $('#subEmailSpan').on('click', subscribeBoxSwitch);
            }

            if (customHeaderNamespaces.includes(this.namespace)) {
                $('#mainNavbar').addClass('d-none');

                // Append Navbar from MainNavbar to Design Center Navbar
                let navLinksTexts = [];
                $('#navbarLinksContainer > li > a').each( function () {
                    let navLinkText = {};
                    navLinkText['link'] = $(this).attr('href');
                    navLinkText['text'] = $(this)[0].childNodes[0].nodeValue.trim();
                    navLinksTexts.push(navLinkText);
                });
                let designCenterHeader = Cache.get('designcenterHeader') || <DesignCenterHeader linkstexts={navLinksTexts} />;
                ReactDOM.render(designCenterHeader, document.getElementById('design-center-header'));
                Cache.set('designcenterHeader', designCenterHeader);

                $('#design-center-wrapper').addClass('d-flex flex-wrap');

                $('#design-center-headline').addClass('design-center-left-col');

                // Append Design Center Headline from wp-admin to React by ID
                let designCenterHeadlineText = $('#design-center-headline-info').attr('data-title');
                let designCenterHeadlineSubText = $('#design-center-headline-info').attr('data-subtitle');
                if (!Cache.get('designcenterHeadlineComponent')) {
                    const designCenterHeadlineComponent = ReactDOM.render( <DesignCenterHeadline
                        text = {designCenterHeadlineText} subtext = {designCenterHeadlineSubText} />,
                        document.getElementById('design-center-headline'));

                    Cache.set('designcenterHeadlineComponent', designCenterHeadlineComponent);
                    designCenterHeadlineComponent.setNamespace(this.namespace);

                    const query = qs.parse(location.search);
                    if (query.state) {
                        designCenterHeadlineComponent.setPageState(query.state);
                    }
                    else {
                        designCenterHeadlineComponent.setPageState(null);
                    }

                    query.state = 'category';
                    delete query.cat;
                    delete query.type;
                    designCenterHeadlineComponent.setUrlQuery(location.pathname + '?' + qs.stringify(query));
                } else {
                    const designCenterHeadlineComponent = Cache.get('designcenterHeadlineComponent');
                    designCenterHeadlineComponent.setNamespace(this.namespace);

                    const query = qs.parse(location.search);
                    if (query.state) {
                        designCenterHeadlineComponent.setPageState(query.state);
                    }
                    else {
                        designCenterHeadlineComponent.setPageState(null);
                    }

                    query.state = 'category';
                    delete query.cat;
                    delete query.type;
                    designCenterHeadlineComponent.setUrlQuery(location.pathname + '?' + qs.stringify(query));
                }

                $('#design-center-content').addClass('design-center-right-col');
                //$('#mainFooter').addClass('d-none');
                //$('#mainFooterSwoosh').addClass('d-none');

                // Disable Scroll when Responsive Design Center Side Menu is shown
                $('#designCenterNav').on('show.bs.collapse', function () {
                    $('body').addClass('side-menu-body-endoplus');
                });
                $('#designCenterNav').on('hide.bs.collapse', function () {
                    $('body').removeClass('side-menu-body-endoplus');
                });
                $(window).on('resize', function () {
                    $('#designCenterNav').collapse('hide');
                });

                if (designCenterPreviewNamespaces.includes(this.namespace)) {
                    $('.design-center-navbar__search-wrapper').addClass('d-sm-flex');
                }
                else {
                    $('.design-center-navbar__search-wrapper').removeClass('d-sm-flex');
                }
            }
            else {
                $('#mainNavbar').removeClass('d-none');
                ReactDOM.unmountComponentAtNode(document.getElementById('design-center-header'));
                $('#design-center-wrapper').removeClass('d-flex flex-wrap');
                $('#design-center-headline').removeClass('design-center-left-col');

                Cache.set('designcenterHeadlineComponent', null);
                ReactDOM.unmountComponentAtNode(document.getElementById('design-center-headline'));

                $('#design-center-content').removeClass('design-center-right-col');
                //$('#mainFooter').removeClass('d-none');
                //$('#mainFooterSwoosh').removeClass('d-none');

                // Disable Multiple Footer Subscribe Submission
                $('form#subscribeForm').submit(function(){
                    $(this).children('button[type=submit]').prop('disabled', true);
                });

                // Disable Scroll when Responsive Main Side Menu is shown
                $('#navbarTogglerHeader').on('show.bs.collapse', function () {
                    $('body').addClass('side-menu-body-endoplus');
                });
                $('#navbarTogglerHeader').on('hide.bs.collapse', function () {
                    $('body').removeClass('side-menu-body-endoplus');
                });
                $(window).on('resize', function () {
                    if (window.innerWidth >= 1200)
                        $('#navbarTogglerHeader').collapse('hide');
                });
            }

            if (customFooterNamespaces.includes(this.namespace)) {
                $('#categoryFooter').removeClass('d-none');
            }
            else {
                $('#categoryFooter').addClass('d-none');
            }
            const query =  qs.parse(location.search);
            const isAccessoriesDetailPage = (query.state === 'category-product' || query.state === 'search-product') && query.type === "accessories";
           if (designCenterPreviewNamespaces.includes(this.namespace)) {
                if (!Cache.get('designcenterPreview')) {
                    const designCenterPreview = <DesignCenterPreview />;
                    const designCenterComponent = ReactDOM.render(designCenterPreview, document.getElementById('design-center'));
                    Cache.set('designcenterPreview', designCenterPreview);
                    Cache.set('designCenterComponent', designCenterComponent);

                    if (query.selectedhandle) {
                        const productBase64 = $(`[data-item-id=${query.selectedhandle}] [type=hidden]`).val();
                        if (productBase64) {
                            const productInfo = JSON.parse(Base64.decode(productBase64));
                            designCenterComponent.setProductData(productInfo);
                        }
                    }

                    if (query.selectedjaw) {
                        const productBase64 = $(`[data-item-id=${query.selectedjaw}] [type=hidden]`).val();
                        if (productBase64) {
                            const productInfo = JSON.parse(Base64.decode(productBase64));
                            designCenterComponent.setProductData(productInfo);
                        }
                    }
                }
               const designCenterComponent = Cache.get('designCenterComponent');
               if (isAccessoriesDetailPage) {
                   designCenterComponent.hide();
               } else {
                   designCenterComponent.show();
               }
            }
            else {
                Cache.set('designcenterPreview', null);
                Cache.set('designCenterComponent', null);
                ReactDOM.unmountComponentAtNode(document.getElementById('design-center'));
            }

            onEnter && onEnter.bind(this)();
        },
        onEnterCompleted: function() {
            onEnterCompleted && onEnterCompleted.bind(this)();
        },
        onLeave: function() {
            if ($('#subEmailSpan').length) {
                $('#subEmailSpan').off('click', subscribeBoxSwitch);
            }

            onLeave && onLeave.bind(this)();
        },
        onLeaveCompleted: function() {
            onLeaveCompleted && onLeaveCompleted.bind(this)();
        }
    });
}
